import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/board/re_btn.png'


const _withScopeId = n => (_pushScopeId("data-v-f56237f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = {
  key: 0,
  class: "board_search_v2 board_search_wrap"
}
const _hoisted_7 = { class: "bo_sch_content" }
const _hoisted_8 = { class: "sch_box" }
const _hoisted_9 = { class: "bo_sch_content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bo_sch_tit" }, "기간", -1))
const _hoisted_11 = { class: "sch_btns" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "board_cate_btns" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "board_graph_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_TotalChart = _resolveComponent("TotalChart")!
  const _component_SearchChart = _resolveComponent("SearchChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            ($setup.state.tabmenu !== 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_DateRange, {
                          date: $setup.state.date,
                          onChangeDate: $setup.selectDate
                        }, null, 8, ["date", "onChangeDate"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sch_btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.getData()))
                        }, "검색하기"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sch_re_btn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.resetFilter()))
                        }, [
                          _hoisted_12,
                          _createTextVNode(" 초기화 ")
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["board_top statis", { no_filter: $setup.state.tabmenu === 1 }])
            }, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabMenu, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass({ active: $setup.state.tabmenu === item.idx }),
                    onClick: ($event: any) => ($setup.selectTab(item.idx))
                  }, _toDisplayString(item.name), 11, _hoisted_14))
                }), 256))
              ])
            ], 2),
            _createElementVNode("div", _hoisted_15, [
              ($setup.state.tabmenu === 1)
                ? (_openBlock(), _createBlock(_component_TotalChart, {
                    key: 0,
                    loading: $setup.state.isLoading,
                    chartData: $setup.chartData.total
                  }, null, 8, ["loading", "chartData"]))
                : ($setup.state.tabmenu === 2)
                  ? (_openBlock(), _createBlock(_component_SearchChart, {
                      key: 1,
                      loading: $setup.state.isLoading,
                      chartData: $setup.chartData.performance
                    }, null, 8, ["loading", "chartData"]))
                  : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}